import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Errors from 'components/shared/Errors';
import Main from 'components/templates/Main';
import PATHS from 'constants/paths';
import { hasHosted } from 'selectors/user';
import ComplaintTabs from '../components/ComplaintTabs';
import ComplaintsList from '../components/ComplaintsList';
import { fetchComplaintsRequest, complaintsReset } from '../redux/actionCreators';
import * as selectors from '../redux/selectors';

const ComplaintsListContainer = () => {
  const dispatch = useDispatch();
  const error = useSelector(selectors.error);
  const isLoading = useSelector(selectors.isLoading);
  const list = useSelector(selectors.list);
  const showHostTab = useSelector(hasHosted);

  React.useEffect(() => {
    dispatch(fetchComplaintsRequest());
    return () => dispatch(complaintsReset());
  }, []);

  return (
    <Main title={<FormattedMessage id="main.complaints" defaultMessage="Complaints" />}>
      <ComplaintTabs tab={0} showHostTab={showHostTab} />
      <ComplaintsList
        list={list}
        isLoading={isLoading}
        basePath={PATHS.complaints.root}
        view="guest"
      />
      <Errors errors={error} />
    </Main>
  );
};

export default ComplaintsListContainer;
